module.exports = __webpack_public_path__ + "static/media/phone_cropped.43e3ca0c.png";